import type { FeatureFlagValueType } from '@brightdrop/feature-flags-client';

import SupportIcon from '~/assets/icons/new/help-circle.svg?react';
import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { SUPPORT_CONTACT_PATH } from '~/common/models/pages/supportPages.model';
import { RouteName } from '~/common/models/route.model';
import { findRoute, makeRoutePath } from '~/common/utils/route/route.utils';

const generateTestId = (
  base: string,
  value: string,
  suffix = 'nav-list-item'
) => {
  return `${base}-${value}-${suffix}`;
};

export const getSupportNavBarItems = (
  findFlagScope?: (flagName: string) => FeatureFlagValueType | undefined
) => [
  {
    label: translateText('common:header.support'),
    testId: generateTestId('account', 'support', 'header'),
    icon: <SupportIcon className="noFill" />,
    path: makeRoutePath({
      pathInfo: findRoute(RouteName.FAQS),
      exact: true,
      findFlagScope,
    }),
    children: [
      {
        label: translateText('account:support.nav.faqs'),
        testId: generateTestId('account-support', 'faqs'),
        path: makeRoutePath({
          pathInfo: findRoute(RouteName.FAQS),
          exact: true,
          findFlagScope,
        }),
      },
      {
        label: translateText('account:support.nav.contact'),
        testId: generateTestId('account-support', 'contact'),
        path: SUPPORT_CONTACT_PATH,
      },
    ],
  },
];
